// src/views/words-list/WordsList.schema.ts
import * as Yup from 'yup';

const INITIAL_VALUES: {
  name: string;
  description: string;
  sharedStudentIds: number[];
  words: any[];
} = {
  name: '',
  description: '',
  sharedStudentIds: [],
  words: [],
};

// Zwrot i definicja słowa — na karcie listy i w okienku „edytuj termin” w grach
const MAX_WORD_FIELD_LENGTH = 100;

const getValidationSchema = (t: any) => Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(95)
    .required(t('words-list:wordsListForm.validation.name.required')),
  description: Yup.string()
    .trim()
    .max(95)
    .required(t('words-list:wordsListForm.validation.description.required')),
});

export { getValidationSchema, INITIAL_VALUES, MAX_WORD_FIELD_LENGTH };
